import React, { useState } from 'react';
import { InformationCard } from '@europrocurement/flexy-components';
import {
    ADD_TIERS_CTX,
    Tiers,
    useTiersCtxDispatch,
} from '@europrocurement/l2d-modules/providers/TiersProvider';
import { enqueueSnackbar } from 'notistack';
import { usePrescriberCRM } from '../../hooks';
import PrescriberInfoCardView from './PrescriberInfoCardView';
import PrescriberInfoCardEdit, { PrescriberInfoFormValues } from './PrescriberInfoCardEdit';

export type PrescriberInfoCardProps = {
    title: string;
    tiers: Tiers;
};

const PrescriberInfoCard: React.FunctionComponent<PrescriberInfoCardProps> = function ({
    title,
    tiers,
}) {
    const { syncTiers } = usePrescriberCRM();
    const tiersDispatch = useTiersCtxDispatch();
    const [isEditing, setIsEditing] = useState<boolean>(false);

    const handleInfoSubmit = async (values: PrescriberInfoFormValues) => {
        setIsEditing(false);

        const updatedTiers: Tiers = {
            ...tiers,
            raisonSociale: values.raisonSociale,
            siren: values.siren,
            codeComptable: values.codeComptable,
            tvaIntracommunautaire: values.tvaIntracommunautaire || undefined,
            regimeTva: values.regimeTva || undefined,
            adresse: {
                ...tiers.adresse,
                adresse1: values.adresse,
                adresse2: values.adresseComplement,
                codePostal: values.codePostal,
                ville: values.ville,
                codePays: values.codePays,
                fullAddress: values.fullAddress,
            },
        };

        if (tiersDispatch) {
            tiersDispatch({ type: ADD_TIERS_CTX, payload: updatedTiers });
        }

        try {
            await syncTiers(updatedTiers);
        } catch (e) {
            console.error(e);
            enqueueSnackbar('Une erreur est survenue lors de la mise à jour du prescripteur', {
                variant: 'error',
            });
            setIsEditing(true);
        }
    };

    return (
        <InformationCard
            title={title}
            subtitle={false}
            button={{
                label: isEditing ? 'Annuler' : 'Éditer',
                onClick: () => setIsEditing(!isEditing),
            }}
            items={[]}
            listComponent={
                isEditing ? (
                    <PrescriberInfoCardEdit
                        tiers={tiers}
                        onSubmit={handleInfoSubmit}
                    />
                ) : (
                    <PrescriberInfoCardView tiers={tiers} />
                )
            }
        />
    );
};

export default PrescriberInfoCard;
